import React, { useEffect, useState } from 'react';

import {
  Box,
  Paper,
  TextareaAutosize,
  TextField,
  Typography,
} from '@mui/material';

import { Reason } from '../../../../../common/constants/reasons';
import { Resource } from '../../../../../common/constants/resource';
import { MibCodeDetails } from '../../../../tasks/types/mibCodeDetails';
import { ReasonsChoicePanel } from '../../ReasonsChoicePanel';
import { RequiredFieldErrorBar } from '../../RequiredFieldErrorBar';
import styles from '../../styles.module.scss';

export const MibCodeDetailsLayout = ({
  data,
  setData,
  isExpanded,
  reasons,
  error,
  description,
}: {
  data: MibCodeDetails;
  setData: React.Dispatch<React.SetStateAction<MibCodeDetails>>;
  isExpanded: boolean;
  reasons: Reason[];
  error: boolean;
  description: string;
}) => {
  const [reasonDescription, setReasonDescription] = useState(
    data.reasonDescription || '',
  );
  const [selectedReasons, setSelectedReasons] = useState(
    data.reason || ([] as string[]),
  );
  const [mibCode, setMibCode] = useState(data.code ?? '');

  useEffect(() => {
    const newData = {} as MibCodeDetails;
    if (isExpanded) {
      newData.reason = selectedReasons;
      newData.reasonDescription = reasonDescription;
      newData.code = mibCode;
    } else {
      setReasonDescription('');
      setSelectedReasons([] as string[]);
      setMibCode('');
    }
    setData(newData);
  }, [isExpanded, reasonDescription, selectedReasons.length, mibCode]);

  return (
    <Box>
      {error && (
        <Box mb={1}>
          <RequiredFieldErrorBar />
        </Box>
      )}

      <Box>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {Resource.DESCRIPTION}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2">{description}</Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {Resource.MIB_CODE}
        </Typography>
      </Box>
      <Box>
        <TextField
          variant="outlined"
          fullWidth
          margin="dense"
          onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
            setMibCode(ev.currentTarget.value);
          }}
        />
      </Box>

      <Box mt={3}>
        <Paper
          elevation={0}
          style={{ backgroundColor: 'var(--neutrals-night-10)' }}
        >
          <Box p={1.5} pt={1.5}>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              {Resource.ORDER_REASON}
            </Typography>
            <ReasonsChoicePanel
              reasons={reasons}
              selectedReasons={selectedReasons}
              selectReasonsCallback={setSelectedReasons}
            />
            <Box mt={2}>
              <TextareaAutosize
                name="reason"
                data-tid="mib-code-details-reason-textarea"
                placeholder="Describe the reason"
                className={styles.MUTextareaInput}
                onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
                  setReasonDescription(ev.currentTarget.value);
                }}
                value={reasonDescription}
                minRows={3}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
